(() => {
  const pixelId = '1097839234829730';
  let loaded = false;
  const recommendationViews = new Set();
  const visibleRecommendations = new Set();
  function recommendationEvent(name, card) {
    if (!loaded || !processingAllowed() || !window.fbq) return;
    window.fbq('trackSingleCustom', pixelId, name, {
      content_ids: [card.dataset.recommendationProduct],
      content_type: 'product_group',
      placement: 'product_recommendations',
      source_product_id: product ? String(product.id) : ''
    });
  }
  function recommendationImpression(card) {
    const id = card.dataset.recommendationProduct;
    if (!loaded || !processingAllowed() || recommendationViews.has(id)) return;
    recommendationEvent('RecommendationView', card);
    recommendationViews.add(id);
  }
  let viewed = false;
  let currentCart;
  let checkoutTracked = false;
  const productData = document.querySelector('[data-ib-marketing-product]');
  const product = productData ? JSON.parse(productData.textContent) : null;
  function track(name, payload, eventId) {
    if (!loaded || !processingAllowed()) return;
    // Only these explicit, non-personal fields enter marketing events.
    window.fbq('trackSingle', pixelId, name, payload, {eventID: eventId || crypto.randomUUID()});
  }

  function processingAllowed() {
    const privacy = window.Shopify?.customerPrivacy;
    return Boolean(
      privacy?.analyticsProcessingAllowed?.() &&
      privacy?.marketingAllowed?.()
    );
  }

  function loadPixel() {
    if (loaded || !processingAllowed()) return;
    loaded = true;

    /* Meta's standard loader, deferred until Shopify confirms consent. */
    ((f, b, e, v, n, t, s) => {
      if (f.fbq) return;
      n = f.fbq = function () {
        n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
      };
      if (!f._fbq) f._fbq = n;
      n.push = n;
      n.loaded = true;
      n.version = '2.0';
      n.queue = [];
      t = b.createElement(e);
      t.async = true;
      t.src = v;
      s = b.getElementsByTagName(e)[0];
      s.parentNode.insertBefore(t, s);
    })(window, document, 'script', 'https://connect.facebook.net/en_US/fbevents.js');

    window.fbq('set', 'autoConfig', false, pixelId);
    window.fbq('init', pixelId);
    window.fbq('consent', 'grant');
    track('PageView', {});
  }

  function syncConsent() {
    if (processingAllowed()) {
      loadPixel();
      window.fbq('consent', 'grant');
      visibleRecommendations.forEach(recommendationImpression);
      if (product && !viewed) {
        track('ViewContent', {content_ids: [String(product.id)], content_type: 'product_group', value: product.price / 100, currency: product.currency});
        viewed = true;
      }
    } else if (loaded && window.fbq) {
      window.fbq('consent', 'revoke');
    }
  }

  function initialize() {
    const observer = new IntersectionObserver(entries => {
      for (const entry of entries) {
        if (entry.isIntersecting && entry.intersectionRatio >= 0.5) {
          visibleRecommendations.add(entry.target);
          recommendationImpression(entry.target);
        } else visibleRecommendations.delete(entry.target);
      }
    }, { threshold: 0.5 });
    document.querySelectorAll('[data-recommendation-product]').forEach(card => observer.observe(card));
    document.addEventListener('click', event => {
      const link = event.target.closest('[data-recommendation-product] a[href]');
      if (link) recommendationEvent('RecommendationClick', link.closest('[data-recommendation-product]'));
    });
    document.addEventListener('visitorConsentCollected', syncConsent);
    document.addEventListener('cart:update', event => {
      const {resource, data, sourceId} = event.detail || {};
      if (resource?.items) currentCart = resource;
      if (data?.source !== 'product-form-component' || data.didError || !resource?.items) return;
      const item = resource.items.find(item => String(item.variant_id) === String(sourceId));
      const quantity = Number(data.itemCount);
      if (!item || !quantity) return;
      track('AddToCart', {content_ids: [String(item.product_id)], content_type: 'product_group', contents: [{id:String(item.product_id),quantity}], value: item.final_price * quantity / 100, currency: resource.currency});
    });
    document.addEventListener('ib:inquiry-success', event => {
      if (loaded && processingAllowed()) track('Lead', {content_name: event.detail.kind}, event.detail.eventId);
    });
    document.addEventListener('click', event => {
      const whatsapp = event.target.closest('a[href*="wa.me/"], a[href*="api.whatsapp.com/"]');
      if (whatsapp && loaded && processingAllowed()) window.fbq('trackSingleCustom', pixelId, 'WhatsAppClick', {});
      if (!event.target.closest('[name="checkout"], a[href="/checkout"]') || checkoutTracked) return;
      const cart = currentCart || JSON.parse(document.querySelector('[data-ib-marketing-cart]')?.textContent || 'null');
      if (!cart?.item_count) return;
      track('InitiateCheckout', {value:cart.total_price / 100, currency:cart.currency, num_items:cart.item_count});
      checkoutTracked = processingAllowed();
    }, {capture:true});

    if (window.Shopify?.customerPrivacy) {
      syncConsent();
      return;
    }

    window.Shopify?.loadFeatures?.(
      [{ name: 'consent-tracking-api', version: '0.1' }],
      (error) => {
        if (!error) syncConsent();
      }
    );
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initialize, { once: true });
  } else {
    initialize();
  }
})();
